module.exports = __webpack_public_path__ + "static/media/web_buttons_briefcase.ecb084f1.svg";